import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import Image from 'molecules/Image';

import { ComparisonTableConfigProps } from 'components/Tables/Comparison/config';

interface ComparisonHeaderLogoProps extends Pick<ComparisonTableConfigProps, 'competitor'> {
  isPrismatic?: boolean;
}

const logoStyles = 'h-8 max-h-8 w-fit object-cover';

const ComparisonHeaderLogo: FC<ComparisonHeaderLogoProps> = ({ competitor, isPrismatic }) =>
  isPrismatic ? (
    // The logo is an image, which some LLMs/bots skip even with alt text, so the column name is also plain text.
    <>
      <Image url="/prismatic-logo-black.svg" alt="Prismatic" className={twJoin(logoStyles, 'aspect-[154_/_32]')} />
      <span className="sr-only">Prismatic</span>
    </>
  ) : (
    <span className="font-roboto text-xl font-semibold leading-6 text-white">
      {competitor?.competitorName ?? 'Competitor'}
    </span>
  );

export default ComparisonHeaderLogo;
